import React, { useContext, useRef, useState } from 'react';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';

import { Card, CardContent, MenuItem, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

import Typography from '@mui/material/Typography';

const PREFIX = 'PurchasesTable';

const classes = {
  root: `${PREFIX}-root`,
  content: `${PREFIX}-content`,
  inner: `${PREFIX}-inner`,
  nameContainer: `${PREFIX}-nameContainer`,
};

const StyledCard = styled(Card)(({ theme }) => ({
  [`&.${classes.root}`]: {
    overflowX: 'auto',
  },

  [`& .${classes.content}`]: {
    padding: 0,
  },

  [`& .${classes.inner}`]: {
    minWidth: 600,
  },

  [`& .${classes.nameContainer}`]: {
    display: 'flex',
    alignItems: 'center',
  },
}));

const PurchasesTable = props => {
  const { className, meetupId, purchases, ...rest } = props;

  if (!purchases) {
    return null;
  }

  return (
    <StyledCard {...rest} className={clsx(classes.root, className)}>
      <CardContent className={classes.content}>
        <div className={classes.inner}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Товар</TableCell>
                <TableCell>Цена</TableCell>
                <TableCell>Дата</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {purchases.map((purch, i) => (
                <TableRow className={classes.tableRow} hover key={purch.purchaseId}>
                  <TableCell>
                    <Typography>{purch.merch.name}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography>{purch.payment.amount}</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography>{purch.payment.date}</Typography>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </StyledCard>
  );
};

export default PurchasesTable;
